import { forwardRef } from "react";

import { WifiOutline24Icon } from "@vygruppen/spor-icon-react";
import type { ButtonProps } from "@vygruppen/spor-react";
import { Button } from "@vygruppen/spor-react";
import { omit } from "@chakra-ui/utils";

import { useNetworkConnectivity } from "~/features/network-connectivity/use-network-connectivity";
import { useHydrated } from "~/hooks/use-hydrated";

export const NetworkDependentButton = forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, "as">
>(function NetworkDependentButton(props, ref): React.ReactNode {
  const isHydrated = useHydrated();

  const { isOnline } = useNetworkConnectivity();

  const isNotHydratedOrOnline = !isOnline || !isHydrated;

  return (
    <Button
      ref={ref}
      {...(isNotHydratedOrOnline ? omit(props, ["onClick"]) : props)}
      leftIcon={isNotHydratedOrOnline ? <WifiOutline24Icon /> : props.leftIcon}
      isDisabled={isNotHydratedOrOnline || props.isDisabled}
      title={
        isNotHydratedOrOnline ? "Kan ikke utføres uten nett." : props.title
      }
    />
  );
});
